import image1 from "../../assets/mininako.png"
import image2 from "../../assets/geslyardiansyah.png"
import image3 from "../../assets/apmedia.png"
import image4 from "../../assets/sircode.png"
import image5 from "../../assets/berkahcipthanusa.png"

import { FaReact } from "react-icons/fa"
import { SiTailwindcss, SiNextdotjs, SiFramer, SiVite, SiCss3 } from "react-icons/si"

export const Data = [
  {
    title: "Mininako",
    image: image1,
    subtitle:"Company profile untuk bisnis bouquet yang menjual berbagai jenis bouquet seperti bunga, uang, dan makanan. Website ini menampilkan produk, katalog, dan informasi perusahaan secara menarik dan elegan.",
    link: "https://mininako.vercel.app",
    tech: [
      <FaReact color="#61DBFB" key="react" />,
      <SiCss3 color="#264de4" key="css" />
    ]
  },
  {
    title: "Gesly Ardiansyah",
    image: image2,
    subtitle: "Website personal untuk menampilkan karya dan aktivitas Gesly Ardiansyah, seorang model, penyanyi, dan content creator. Berfungsi sebagai media branding profesional sekaligus showcase karya terbaru.",
    link: "https://geslyardiansyah.site",
    tech: [
      <SiNextdotjs color="#000000" key="next" />,
      <SiTailwindcss color="#38BDF8" key="tailwind" />,
      <SiFramer color="#E10098" key="framer" />
    ]
  },
  {
    title: "AP Media",
    image: image3,
    subtitle: "Platform digital untuk content creator horor yang berfokus pada podcast, short movie, storytelling, dan eksplorasi tempat angker. Website ini menjadi wadah branding dan distribusi konten horor secara profesional.",
    link: "https://sircode.web.id/ap-media",
    tech: [
      <FaReact color="#61DBFB" key="react" />,
      <SiVite color="#646CFF" key="vite" />,
      <SiCss3 color="#264de4" key="css" />
    ]
  },
  {
    title: "Sir Code",
    image: image4,
    subtitle: "Website jasa pembuatan landing page, company profile, dan desain website. Dibangun sebagai platform bersama dengan teman untuk membantu bisnis dan personal dalam memiliki tampilan digital yang modern dan profesional.",
    link: "https://sircode.web.id",
    tech: [
      <SiNextdotjs color="#000000" key="next" />,
      <SiTailwindcss color="#38BDF8" key="tailwind" />,
      <SiFramer color="#E10098" key="framer" />
    ]
  },
  {
    title: "Berkah Ciptha Nusa",
    image: image5,
    subtitle: "Website company profile untuk perusahaan di bidang interior. Menampilkan layanan, portofolio proyek, dan informasi perusahaan agar calon klien dapat mengenal lebih dekat serta meningkatkan kredibilitas perusahaan.",
    link: "https://berkahcipthanusa.web.id/",
    tech: [
      <SiNextdotjs color="#000000" key="next" />,
      <SiTailwindcss color="#38BDF8" key="tailwind" />,
    ]
  }
]
